const state = () => ({
    xcrossSeller:[],
    garantie:[],
    upgrades:[],
    itemsToDelete:[]
});

const mutations =
    {
        setXCrossSeller(state, request)
        {
            state.xcrossSeller = request;
        },
        setGarantie(state, request)
        {
            state.garantie = request;
        },
        setUpgrades(state, request)
        {
            state.upgrades.push(request);
        },
        setAllItemsToDelete(state, items)
        {
            state.itemsToDelete = items;
        },
        toggleItemToDelete(state, item)
        {
            const currentItems = state.itemsToDelete;
            const index = currentItems.indexOf(item);

            if (index > -1)
            {
                state.itemsToDelete = currentItems.filter(i => i !== item);
            }
            else
            {
                state.itemsToDelete.push(item);
            }
        }
    };

export default
{
    state,
    mutations
};
